import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {
  static targets = ["menu", "closeArea", "container", "button"]
  connect() {
    this.boundOutside = this.handleOutside.bind(this)
    this.boundFocusTrap = this.focusTrap.bind(this)
  }

  toggle() {
    this.isOpen() ? this.close() : this.open();
  }

  open() {
    if (this.isOpen()) return;
    this.menuTarget.classList.remove("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "true")
    document.addEventListener("click", this.boundOutside)
    document.addEventListener("focusin", this.boundFocusTrap)
    this.focusFirstItem()
  }

  openFromKey(event) { event.preventDefault(); this.open() }

  close() {
    if (!this.isOpen()) return
    this.menuTarget.classList.add("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "false")
    document.removeEventListener("click", this.boundOutside)
    document.removeEventListener("focusin", this.boundFocusTrap)
    this.buttonTarget.focus()
  }

  isOpen() {
    return !this.menuTarget.classList.contains("hidden")
  }

  handleOutside(event) {
    if (this.menuTarget.classList.contains("hidden")) return;

    const clickedInsideMenu =
      this.containerTarget.contains(event.target) &&
      event.target !== this.closeAreaTarget;

    const clickedInsideButton = this.buttonTarget.contains(event.target);

    if (!clickedInsideMenu && !clickedInsideButton) {
      this.menuTarget.classList.add("hidden");
    }
  }

  focusTrap(event) {
    if (this.isOpen() && !this.element.contains(event.target)) {
      this.focusFirstItem()
    }
  }

  focusFirstItem() {
    const item = this.menuTarget.querySelector('[role="menuitem"]')
    item && item.focus()
  }

  activate(event) {
    this.close()
  }
}
